module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Double-check-9473c5957fa0065e8f7b98ac8456e455.svg";